import { createReducer, } from 'typesafe-actions';

import { fetchOrder, } from './actions';

const orderInitialState = {
    isLoading: false,
    isError: false,
    errorMessage: null,
    errorCode: null,
    data: null,
};

const orderReducer = createReducer(orderInitialState)
    .handleAction(fetchOrder.request, (state,) => ({ ...state, isLoading: true, }))
    .handleAction(fetchOrder.success, (state, action) => ({
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
    }))
    .handleAction(fetchOrder.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload.data?.reason ?? action.payload.message,
        errorCode: action.payload?.code,
    }));

export default orderReducer;
